<template>
  <main>
    <div class="title">
      北海道教育大学函館校 青木研究室 Webアプリケーション
      <h1>{{title}}</h1>
    </div>
    <InputMatrix :calc="calc" :original="original" :config="calc == 'eqn' ? config : defaultConfig"
		 :keep="keep" @finish="newMatrix"></InputMatrix>
    <template v-if="valid">
      <Determinant v-if="calc=='det'" :original="original" ref="part"></Determinant>
      <Reduction v-else :calc="calc" :original="original" :config="calc == 'eqn' ? config : defaultConfig" ref="part"></Reduction>
    </template>
  </main>
</template>

<script>
import { Config } from '@/lib/base.js'
import InputMatrix from '@/components/InputMatrix.vue'
import Determinant from '@/components/Determinant.vue'
import Reduction from '@/components/Reduction.vue'

export default {
  name: 'Main',
  components: {
    InputMatrix,
    Determinant,
    Reduction,
  },
  props: {
    calc: String
  },  
  data: function(){
    return {
      original: [],
      config: new Config('eqn'),
      defaultConfig: new Config('none'),
      valid: false,
    }
  },
  created: function(){
    window.addEventListener('keyup', this.keyUp, {passive:true});
  },
  beforeDestroy: function(){
    window.removeEventListener('keyup', this.keyUp, {passive:true});
  },
  computed: {
    title(){
      return this.calc == 'det' ? '行列式の計算' :
	this.calc == 'reduce' ? '行列の簡約化' :
	this.calc == 'eqn' ? '連立方程式を解く' :
	this.calc == 'inverse' ? '逆行列の計算' : 'Unknown';
    },
    keep(){
      return this.$route.params.keep;
    }
  },
  methods: {
    newMatrix(){
      this.valid = false;
      this.$nextTick( () => {this.valid = true;} );
    },
    keyUp(e){
      const type = event.target.type;
      if(type == 'text' || type == 'number'){
        return;
      }
      if(this.$refs.part){
	this.$refs.part.keyUp(e);
      }
    }
  },
  watch: {
    calc(){
      this.valid = false;
    }
  }
}
</script>

<style scoped>
</style>
